import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

function ConfirmBtn({ infos }) {
	return (
		<Fragment>
			{infos.link ? (
				<Link to={infos.link}>
					<button
						className="actionBtnRow__button actionBtnRow__confirmBtn"
						onClick={infos.method}
						type={infos.type ? infos.type : 'button'}
					>
						{infos.text ? infos.text : 'Confirmer'}
					</button>
				</Link>
			) : (
				<button
					className="actionBtnRow__button actionBtnRow__confirmBtn"
					onClick={infos.method}
					type={infos.type ? infos.type : 'button'}
				>
					{infos.text ? infos.text : 'Confirmer'}
				</button>
			)}
		</Fragment>
	);
}

export default ConfirmBtn;
